import axios from "axios";
import { ElMessage } from "element-plus";
import router from "../router";
import { getToken, clearToken } from "../utils/token";

const API_BASE = process.env.VUE_APP_API_BASE || "https://ysy.yishuyun.shop";
const HTML_RESPONSE_MSG = "接口返回了网页而不是数据，请检查 API 地址（应为 https://ysy.yishuyun.shop）";

const isHtmlPayload = (data) => typeof data === "string" && /^\s*</.test(data);

const http = axios.create({
    baseURL: API_BASE,
    timeout: 15000
});

http.interceptors.request.use((config) => {
    // 调试信息：打印实际请求 URL
    const fullUrl = config.baseURL + config.url;
    console.log('请求 URL:', {
        baseURL: config.baseURL,
        url: config.url,
        fullUrl: fullUrl
    });
    
    // 登录接口不需要 token
    const isLoginRequest = config.url?.includes('/auth/admin/login');
    if (!isLoginRequest) {
        const token = getToken();
        if (token) {
            config.headers = config.headers ?? {};
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

http.interceptors.response.use(
    (resp) => {
        const res = resp.data; // {code,message,data}
        if (isHtmlPayload(res)) {
            ElMessage.error(HTML_RESPONSE_MSG);
            return Promise.reject(new Error(HTML_RESPONSE_MSG));
        }

        const ok = res?.code === 0 || res?.code === 200;
        if (ok) return res;

        const msg = res?.message || "请求失败";
        
        // 调试信息：打印登录失败详情
        if (resp.config?.url?.includes('/auth/admin/login')) {
            console.log('登录失败详情:', {
                url: resp.config.url,
                requestData: resp.config.data,
                response: res
            });
        }

        // 处理 401 未授权 或 403 禁止访问
        if (msg.includes("管理员权限") || msg.includes("未登录") || res?.code === 401 || res?.code === 403) {
            clearToken();
            ElMessage.error("权限不足，请重新登录");
            router.replace("/login");
            const err = new Error(msg);
            err.code = res?.code;
            err.data = res;
            return Promise.reject(err);
        }

        ElMessage.error(msg);

        const err = new Error(msg);
        err.code = res?.code;
        err.data = res;
        return Promise.reject(err);
    },
    (err) => {
        // 处理 HTTP 状态码错误
        const status = err?.response?.status;
        const data = err?.response?.data;
        const msg = isHtmlPayload(data)
            ? HTML_RESPONSE_MSG
            : (data?.message || err?.message || "网络错误");

        // 处理 403 Forbidden 和 401 Unauthorized
        if (status === 403 || status === 401) {
            clearToken();
            ElMessage.error("权限不足，请重新登录");
            router.replace("/login");
            return Promise.reject(err);
        }

        ElMessage.error(msg);
        return Promise.reject(err);
    }
);

export default http;
